/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Updates_Applied_To_All_RoomsInputs */



/**
* | output |
* | --- |
* | "Changes have been applied to all rooms successfully" |
*
* @param {Updates_Applied_To_All_RoomsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const updates_applied_to_all_rooms = /** @type {((inputs?: Updates_Applied_To_All_RoomsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Updates_Applied_To_All_RoomsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Changes have been applied to all rooms successfully")
	return /** @type {LocalizedString} */ ("Les modifications ont bien été appliquées à toutes les pièces")
});